/**
 * Returns the correct login path based on the current domain.
 * ondc.manndeshiebazaar.com → /business-login (Organisation login)
 * All other domains          → /login (Seller login)
 */
export function getLoginPath(): string {
  const host = window.location.hostname;
  if (host === 'ondc.manndeshiebazaar.com') {
    return '/business-login';
  }
  return '/login';
}

export function isBusinessDomain(): boolean {
  return window.location.hostname === 'ondc.manndeshiebazaar.com';
}
